import { render, staticRenderFns } from "./contract-history.vue?vue&type=template&id=8f45b622&"
import script from "./contract-history.vue?vue&type=script&lang=js&"
export * from "./contract-history.vue?vue&type=script&lang=js&"
import style0 from "./contract-history.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports